import { render, staticRenderFns } from "./CidProposal.vue?vue&type=template&id=79cb2629"
import script from "./CidProposal.vue?vue&type=script&lang=js"
export * from "./CidProposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports